'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentOrder = exports.CreateOrder = undefined;

var _CreateOrder2 = require('./CreateOrder');

var _CreateOrder3 = _interopRequireDefault(_CreateOrder2);

var _PaymentOrder2 = require('./PaymentOrder');

var _PaymentOrder3 = _interopRequireDefault(_PaymentOrder2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.CreateOrder = _CreateOrder3.default;
exports.PaymentOrder = _PaymentOrder3.default;


//////////////////
// WEBPACK FOOTER
// ./src/containers/Order/index.js
// module id = 1824
// module chunks = 0